import { Pipe, PipeTransform } from '@angular/core';
import { TIC_NAME } from '@app/config/tic-name.enum';

@Pipe({
  name: 'ticIndex'
})
export class TicIndexPipe implements PipeTransform {

  public dataSelectTic = TIC_NAME.map(b => { return b });

  transform(value: any): number {

    return this.dataSelectTic.findIndex(x => x.id === value);
  }
}
